// Import our Bootstrap extensions
// Import all plugins
import * as bootstrap from 'bootstrap';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist'
import Prism from 'prismjs';
import './vendor';

import { I18n } from "i18n-js";
import en from "../../../locales/en.json";
import es from "../../../locales/es.json";

const i18n = new I18n({
    ...en,
    ...es,
});

window.i18n = i18n;
window.Alpine = Alpine;
Alpine.plugin(persist);

document.addEventListener('alpine:init', () => {
    Alpine.data('boxlangData', function () {
        return {
            isDev: false,
            isOpenMenu: false,
            locale: this.$persist((i18n.locale.length ? i18n.locale : 'en')).as('boxlang-locale'),
            langSelected: {},
            scrolled: false,
            pastNews: {},
            sortedYears: [],

            async init() {
                this.getLangSelected()
                this.isDev = this.setDevTheme();
                this.loadPastNews().then(() => {
                    this.sortedYears = Object.keys( this.pastNews )
                        .sort( ( a, b ) => b - a );
                });

                if( this.isDev ){
                    document.title = "BoxLang DEV";
                }
            },

            languages: [
                {
                    locale: "EN",
                    icon: "/__media/boxlang:flags/en.svg"
                },
                {
                    locale: "ES",
                    icon: "/__media/boxlang:flags/es.svg"
                }
            ],

            setDevTheme(){
                return window.location.hostname.includes('.devs') ? true : false;
            },

            getLangSelected() {
                var lang = this.languages.filter(item => { return item.locale == this.locale.toUpperCase() });
                this.langSelected = Object.keys(lang).length ? lang[0] : this.languages[0];
            },

            getI18nValue(name) {
                return i18n.t(name);
            },

            updateLanguage(language) {
                this.locale = language;
                i18n.locale = language;

                this.getLangSelected()
            },

            async getContributors() {
                let response = await fetch(window.location.origin + '/api/contributors');
                let result = await response.json();
                return result.length ? result : [];
            },
            
            async getNews() {
                let response = await fetch(window.location.origin + '/api/news');
                let result = await response.json();
                return result.length ? result : [];
            },
            
            async loadPastNews() {
                const response = await fetch( window.location.origin + '/api/pastNews' );
                this.pastNews = await response.json() || [];
            },

            getCustomFieldValue(arr, name) {
                return arr.reduce((acc, cur) => {
                    if (cur.key == name) {
                        acc = cur.value;
                    }
                    return acc;
                }, "");
            },

            get isHomePage(){
                let currentURL = window.location.pathname.replace( "/", "" );
                return currentURL.length ? false : true
            }
        }
    })
})

Alpine.start();


window.onload = () => {
    // Update the Bitrix form fields to add them the aria-label attribute
    let listFormFields = document.getElementsByClassName( "b24-form-control-label" );
    if( listFormFields ) {
        for( var i = 0; i < listFormFields.length; i++ ){
            let description = listFormFields[i].textContent.replace(/\r?\n|\r/g, "").replace( "*", "" ).trim();
            listFormFields[i].setAttribute( 'aria-label', description );
        }
    }
}

window.sendProductsListToGTM = ( productList ) => {
    
    if ( window.dataLayer && Array.isArray( window.dataLayer ) ) {
        
        var itemList = productList
            .filter( 
                item => item.kindProduct1.yearPrice !== null && 
                item.kindProduct1.yearPrice !== undefined && 
                item.kindProduct1.yearPrice > 0 
            )
            .map( ( item, index ) => ({
                item_id: item.slug,
                item_name: item.name,
                affiliation: 'BoxLang',
                discount: 0,
                index: index,
                item_brand: 'BoxLang',
                item_category: 'BoxLang',
                item_category2: 'Programming Language',
                item_list_name: 'BoxLang products',
                price: item.kindProduct1.yearPromoPrice > 0 ? Number( item.kindProduct1.yearPromoPrice ) : Number( item.kindProduct1.yearPrice ),
                quantity: 1
            }));

            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
              event: 'view_item_list',
              ecommerce: {
                item_list_id: 'boxlang_products',
                item_list_name: 'BoxLang products',
                items: itemList
              }
            });
    }

}

window.goToCheckOutForm = ( product, url ) => {

    if ( window.dataLayer && Array.isArray( window.dataLayer ) ) {

        // Clear the previous ecommerce object.
        dataLayer.push({ ecommerce: null });

        // Construct the object from the selected item
        let price = product.kindProduct1.yearPromoPrice > 0 ? product.kindProduct1.yearPromoPrice : product.kindProduct1.yearPrice; 
        price = Number( price );

        var itemList = {
            event: 'add_to_cart',
            ecommerce: {
                currency: 'USD',
                value: price,
                items: [
                    {
                        item_id: product.slug,
                        item_name: product.name,
                        affiliation: 'BoxLang',
                        coupon: '',
                        discount: 0,
                        index: 0,
                        item_brand: 'BoxLang',
                        item_category: 'BoxLang',
                        item_category2: 'Programming Language',
                        item_list_id: 'boxlang_products',
                        item_list_name: 'BoxLang Products',
                        location_id: '',
                        price: price,
                        quantity: 1
                    }
                ]
            }
        };
    
        dataLayer.push( itemList );
        window.location.href = url;
    }

}

// Download Modal 
const modal = document.getElementById('newsletterModal');
const modalBody = modal ? modal.querySelector('.modal-body') : null;
// IDs such as mc-embedded-subscribe-form and mc-embedded-subscribe are reused
// in other theme partials, so scope modal lookups to avoid binding to the wrong form.
const newsletterForm = modal ? modal.querySelector('#mc-embedded-subscribe-form') : null;
const mailchimpFrame = modal ? modal.querySelector('#mailchimp-submit-frame') : null;
const continueButton = modal ? modal.querySelector('#continueButton') : null;
const backButton = modal ? modal.querySelector('#backButton') : null;
const modalTitle = modal ? modal.querySelector('#newsletterModalLabel') : null;
const submitButton = modal ? modal.querySelector('#mc-embedded-subscribe') : null;
const downloadNowButton = modal ? modal.querySelector('#downloadNowButton') : null;
const modalIcons = [
    modal ? modal.querySelector('#downloadModalIcon') : null,
    modal ? modal.querySelector('#downloadModalConfirmationIcon') : null
].filter(Boolean);

const directExtensions = [
    '.zip', '.jar', '.war', '.exe', '.msi',
    '.dmg', '.tar', '.gz', '.tgz', '.bz2',
    '.7z', '.rar', '.iso', '.img', '.bin'
];

const directButtonText = 'Subscribe & Download';
const redirectButtonText = 'Subscribe & Continue';
const directDownloadText = 'Download Now';
const redirectDownloadText = 'Open Download Page';

window.downloadModal = {

    selectedDownload: null,
    actionType: 'direct',
    subscriptionSubmitted: false,

    open( item ) {

        if ( !modal ) {
            return;
        }

        // Store the selected download so the modal can complete the flow later.
        this.selectedDownload = item;
        this.actionType = this.inferActionType( item.link || '' );
        this.subscriptionSubmitted = false;

        if ( modalTitle ) {
            modalTitle.textContent = item.name || '';
        }

        modalIcons.forEach( icon => {
            icon.className = `icon text-gradient display-6 ${item.icon || 'icon-bl-horn'}`;
        } );

        if ( submitButton ) {
            submitButton.textContent = this.actionType === 'direct'
                ? directButtonText
                : redirectButtonText;
        }

        if ( downloadNowButton ) {
            downloadNowButton.textContent = this.actionType === 'direct'
                ? directDownloadText
                : redirectDownloadText;
            downloadNowButton.href = this.getSafeLink( item.link );

            if ( this.actionType === 'redirect' ) {
                downloadNowButton.setAttribute( 'target', '_blank' );
            } else {
                downloadNowButton.removeAttribute( 'target' );
            }
        }

        bootstrap.Modal.getOrCreateInstance( modal ).show();

    },
    getSafeLink( url ) {
        if ( !url ) return '#';
        try {
            const parsed = new URL( url, window.location.origin );
            return ( parsed.protocol === 'https:' || parsed.protocol === 'http:' )
                ? parsed.href
                : '#';
        } catch {
            return '#';
        }
    },
    
    inferActionType( url ) {

        const normalizedUrl = ( url || '' ).trim();
        if ( !normalizedUrl.length ) {
            return 'redirect';
        }

        const parsedUrl = new URL( normalizedUrl, window.location.origin );

        const lowerPath = parsedUrl.pathname.toLowerCase();

        return directExtensions.some( extension => lowerPath.endsWith( extension ) )
            ? 'direct'
            : 'redirect';

    },

    continueWithoutSubscription() {

        if ( !this.selectedDownload ) {
            return;
        }

        if ( this.actionType === 'direct' ) {

            showStep( 'download' );

            setTimeout( () => {
                triggerDirectDownload( this.selectedDownload.link );
            }, 1000 );

            return;

        }

        showStep( 'download' );

        // Keep the success screen visible and open the destination in a new tab.
        setTimeout( () => {
            openInNewTab( this.selectedDownload.link );
        }, 150 );

    },

    handleSubscription( event ) {

        const form = event.target;

        if ( !form.checkValidity() ) {

            event.preventDefault();
            form.classList.add( 'was-validated' );
            return;

        }

        // Let the native Mailchimp submit continue, then wait for the iframe load.
        this.subscriptionSubmitted = true;

    },

    handleMailchimpLoad() {

        if ( !this.subscriptionSubmitted ) {
            return;
        }

        this.subscriptionSubmitted = false;
        if ( !this.selectedDownload?.link ) {
            return;
        }

        if ( this.actionType === 'direct' ) {
            showStep( 'download' );

            // Keep the user on BoxLang and start the file download in background.
            setTimeout( () => {
                triggerDirectDownload( this.selectedDownload.link );
            }, 150 );

            return;
        }

        showStep( 'download' );

        // Keep the success screen visible and open the destination in a new tab.
        setTimeout( () => {
            openInNewTab( this.selectedDownload.link );
        }, 150 );

    },

    reset() {

        this.subscriptionSubmitted = false;

        if ( !modal ) {
            return;
        }

        modal.querySelector( '[data-step="download"]' ).classList.add( 'd-none' );
        modal.querySelector( '[data-step="subscribe"]' ).classList.remove( 'd-none' );

        if ( newsletterForm ) {
            newsletterForm.reset();
            newsletterForm.classList.remove( 'was-validated' );
        }

        if ( submitButton ) {
            submitButton.textContent = directButtonText;
        }

        if ( downloadNowButton ) {
            downloadNowButton.textContent = directDownloadText;
            downloadNowButton.href = '#';
            downloadNowButton.removeAttribute( 'target' );
        }

        modalIcons.forEach( icon => {
            icon.className = 'icon text-gradient display-6 icon-bl-horn';
        } );

        if ( modalTitle ) {
            modalTitle.textContent = '';
        }

        modalBody.style.height = '';
        this.selectedDownload = null;
        this.actionType = 'direct';

    }

};

window.openDownloadModal = function( item ) {
    window.downloadModal.open( item );
};

if ( newsletterForm ) {
    newsletterForm.addEventListener( 'submit', event => {
        window.downloadModal.handleSubscription( event );
    } );
}

if ( mailchimpFrame ) {
    mailchimpFrame.addEventListener( 'load', () => {
        window.downloadModal.handleMailchimpLoad();
    } );
}

if ( continueButton ) {
    continueButton.addEventListener( 'click', () => {
        window.downloadModal.continueWithoutSubscription();
    } );
}

if ( backButton ) {
    backButton.addEventListener( 'click', event => {
        event.preventDefault();
        showStep( 'subscribe' );
    } );
}

if ( downloadNowButton ) {
    downloadNowButton.addEventListener( 'click', event => {

        const selectedLink = window.downloadModal.selectedDownload?.link;
        if ( !selectedLink ) {
            return;
        }

        if ( window.downloadModal.actionType === 'direct' ) {
            event.preventDefault();
            triggerDirectDownload( selectedLink );
            return;
        }

        event.preventDefault();
        openInNewTab( selectedLink );

    } );
}

if ( modal ) {
    modal.addEventListener( 'hidden.bs.modal', () => {
        window.downloadModal.reset();
    } );
}

if ( modalBody ) {
    modalBody.addEventListener( 'transitionend', event => {
        if ( event.propertyName === 'height' ) {
            modalBody.style.height = '';
        }
    } );
}

function showStep( stepName ) {

    if ( !modal ) {
        return;
    }

    const current = modal.querySelector( '[data-step]:not(.d-none)' );
    const next = modal.querySelector( `[data-step="${stepName}"]` );

    if ( !current || !next ) {
        return;
    }

    current.classList.add( 'opacity-0' );

    setTimeout( () => {

        current.classList.add( 'd-none' );
        current.classList.remove( 'opacity-0' );

        next.classList.remove( 'd-none' );
        next.classList.add( 'opacity-0' );

        requestAnimationFrame( () => {
            next.classList.remove( 'opacity-0' );
        } );

    }, 180 );

}

function triggerDirectDownload( url ) {

    if ( !url ) {
        return;
    }

    const iframe = document.createElement( 'iframe' );
    iframe.className = 'd-none';
    iframe.setAttribute( 'aria-hidden', 'true' );
    iframe.src = url;

    document.body.appendChild( iframe );

    setTimeout( () => {
        iframe.remove();
    }, 15000 );

}

function openInNewTab( url ) {

    if ( !url ) {
        return;
    }

    const link = document.createElement( 'a' );
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener';

    document.body.appendChild( link );
    link.click();
    link.remove();

}

// Standalone MailChimp forms submit into their own hidden iframe so they can
// show confirmation feedback without navigating away from the current page.
document.querySelectorAll( '[data-mailchimp-signup]' ).forEach( signup => {

    const form = signup.querySelector( '[data-mailchimp-form]' ) || signup.querySelector( 'form' );
    const frame = signup.querySelector( '[data-mailchimp-frame]' );
    const successMessage = signup.querySelector( '[data-mailchimp-success]' );
    let submitted = false;

    if ( !form || !frame ) {
        return;
    }

    form.addEventListener( 'submit', event => {

        if ( !form.checkValidity() ) {
            return;
        }

        submitted = true;

        if ( successMessage ) {
            successMessage.hidden = true;
        }

    } );

    frame.addEventListener( 'load', () => {

        if ( !submitted ) {
            return;
        }

        submitted = false;
        form.reset();

        if ( successMessage ) {
            successMessage.hidden = false;
        }

    } );

} );



/**
 * Synchronizes sidebar navigation with the section currently in view.
 *
 * The sidebar links must point to sections using their IDs:
 * <a href="#section-id">Section</a>
 * <section id="section-id">...</section>
 *
 * @param {string} sidebarSelector - Selector for the navigation sidebar.
 */
function initScrollSpy( sidebarSelector ) {
    const sidebar = document.querySelector( sidebarSelector );
    if ( !sidebar ) {
        return;
    }
  const navLinks = sidebar.querySelectorAll('a[href*="#"]');
  // Get the sections referenced by the sidebar links.
  const sections = Array.from(navLinks)
    .map((link) => {
      const targetId = link.hash;
      if (!targetId || targetId === '#') {
        return null;
      }
      try {
        return document.querySelector(targetId);
      } catch (e) {
        return null;
      }
    })
    .filter(Boolean);
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        const activeSectionId = entry.target.id;
        // Remove the active state from all navigation links.
        navLinks.forEach((link) => {
          link.classList.remove('active');
        });
        // Find the link associated with the visible section.
        const activeLink = Array.from(navLinks).find(
          (link) => link.hash === `#${activeSectionId}`
        );
        // Apply the existing active state.
        activeLink?.classList.add('active');
      });
    },
    {
      // Define the upper reading area where a section becomes active.
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    }
  );
  // Start observing all sections referenced by the sidebar.
  sections.forEach((section) => {
    observer.observe(section);
  });
}
// Initialize Scroll Spy for any sidebar following the anchor convention.
initScrollSpy('.sidebar');